// 📦 Import de React et des hooks nécessaires
import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import ListItems from "../components/ListItems/ListItems.js";
import { Typography, Box ,Paper, useMediaQuery} from "@mui/material";


// 📌 Import du contexte pour récupérer les infos du groupe connecté
import { useGroupe } from "../context/GroupeContext.js";
import QuotaInfo from "../components/QuotaInfo.js";

// 🔑 Hook pour savoir si l'utilisateur est admin dans ce groupe
import { useAdminRole } from "../hooks/useAdminRole.js";

import { useLanguage } from '../context/LanguageContext.js';
//import { logDev } from "../utils/logger.js"; 

const Liste = () => {
  const { t } = useLanguage();
  
    // 🔗 Récupération de l'ID du groupe depuis le contexte
    const { groupeId, nomGroupeComplet, couleur, reloadGroupeActif } = useGroupe();

    const [headerHeight, setHeaderHeight] = useState(0);
    const [bottomNavHeight, setBottomNavHeight] = useState(0);

    const role = useAdminRole(groupeId);
    // 🛡️ Déterminer si l'utilisateur est admin
    const isAdmin = role === "admin";

    // 🎨 Récupération du thème MUI et détection si l'écran est mobile
    const isMobile = useMediaQuery("(max-width:600px)");

    const [footerHeight, setFooterHeight] = useState(0);

    // ⏰ Définition des moments de la journée avec leur clé, label et couleur associée
    const moments = [
      { key: "Matin", label: "Morning", color: "#fff8e1" },
      { key: "Midi",  label: "Noon",    color: "#fff3e0" },
      { key: "Soir",  label: "Evening", color: "#e3f2fd" }
    ];

    useEffect(() => {
      if (groupeId) reloadGroupeActif();
    }, []); // 👈 une seule fois, pas à chaque changement

    useEffect(() => {
      const header = document.querySelector('.header');
      const nav = document.querySelector('.MuiBottomNavigation-root');
      const footer = document.querySelector('.footer');

      const updateHeights = () => {
        if (header) setHeaderHeight(header.offsetHeight);
        if (nav) setBottomNavHeight(nav.offsetHeight);
        if (footer) setFooterHeight(footer.offsetHeight);
      };

      updateHeights();
      window.addEventListener('resize', updateHeights);
      return () => window.removeEventListener('resize', updateHeights);
    }, []);

    useEffect(() => {
      const header = document.querySelector('.header');
      const nav = document.querySelector('.MuiBottomNavigation-root');

      const updateHeights = () => {
        if (header) setHeaderHeight(header.offsetHeight);
        if (nav) setBottomNavHeight(nav.offsetHeight);
      };

      updateHeights();
      window.addEventListener('resize', updateHeights);

      return () => window.removeEventListener('resize', updateHeights);

    }, []);


  const topOffset = headerHeight + (isMobile ? footerHeight : bottomNavHeight) + 16;
  const bottomOffset = isMobile ? bottomNavHeight : footerHeight;


  if (!groupeId) return <Navigate to="/connexion" replace />;



  return (
    <div className="liste-container"
    style={{
      minHeight: "100vh",
      paddingTop: `${topOffset}px`,
      paddingBottom: `${bottomOffset}px`,
      boxSizing: "border-box",
      backgroundColor: "#f4ece2",
      overflowY: "auto"
      }}
    >
      
      {isAdmin && groupeId && (
        <QuotaInfo groupeId={groupeId} isAdmin={isAdmin} />
      )}

      {/** On englobe le nom du groupe + menus dans un Paper */}
      <Paper
      elevation={1}
      sx={{
        backgroundColor: "#f4ece2",
        width: "90vw",
        maxWidth: isMobile ? "95vw" : "1200px", // 👈 limite la largeur
        margin: "0 auto",
        padding: 2,
        }}
      >
        
        {/* 🔔 Notice rôle : message différent pour admin ou utilisateur */}
        <div
        style={{       
          backgroundColor: "#2f2f2fff",
          padding: "12px 16px",
          borderRadius: "6px",
          marginBottom: "12px",
          fontSize: "1rem",
          fontWeight: "bold",
          textAlign: "center",
          color: "#fff",
          border: "2px solid #d4af37", // doré
          boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
          backgroundImage: "radial-gradient(circle at top left, rgba(255,255,255,0.05), transparent 70%)"
          }}
        >

          {isAdmin
            ? t('ListeAdmin') 
            : t("ListeUsers")}

      </div>

        {/* 🏷️ En-tête avec le nom du groupe */}
      <Box 
        sx={{ 
          textAlign: "center", 
          marginBottom: 2, 
        }}
        >
        <Typography
          variant="h6"
          align="center"
          gutterBottom
          sx={{
          color: couleur,
          fontWeight: "bold",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 1
        }}
      >
        <strong>{nomGroupeComplet}</strong>
      </Typography>
      </Box>

    {/* 📋 Affichage de la liste des items pour chaque moment */}
    <ListItems headerHeight={headerHeight} moments={moments} /> 
    </Paper>
    </div>
  );
};

export default Liste;